/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useCallback } from 'react';
import { styled } from 'linaria/react';
import last from 'lodash/last';
import first from 'lodash/first';
import isEmpty from 'lodash/isEmpty';
import { ContextMenu, useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme, useBreadCrumbsData } from '@shared/lib';
import { ContextMenuConfigType } from '@shared/types';
import { mapContextMenu } from '../lib/mapContextMenu';
import { IconWithLabel } from './IconWithLabel';
import { LinkComponent } from './LinkComponent';
import { BreadcrumbsUI } from './BreadcrumbsUI';
export interface BreadcrumbsProps {
  contextMenuConfig?: ContextMenuConfigType[];
  currentPath?: string;
}
const OldBreadcrumbs: FC<BreadcrumbsProps> = () => {
  const {
    isMobile
  } = useBreakpoint();
  const {
    currentPath,
    contextMenuConfig
  } = useBreadCrumbsData();
  const getContextMenuComponent = useCallback(() => {
    const lastElement = last(contextMenuConfig);
    const firstElement = first(contextMenuConfig);
    const isOneElement = contextMenuConfig?.length === 1;
    if (!isMobile) {
      return mapContextMenu(contextMenuConfig as any);
    }
    if (isOneElement) {
      const {
        url,
        label,
        routes
      } = lastElement as any;
      return url ? <LinkComponent label={label} url={url} /> : <ContextMenu component={<IconWithLabel label={label} />}>{routes}</ContextMenu>;
    }
    return mapContextMenu([firstElement as any, lastElement as any]);
  }, [isMobile, contextMenuConfig]);
  const getCurrentPathComponent = useCallback(currentPathConfig => <Text>{currentPathConfig}</Text>, []);
  const ContextMenus = isEmpty(contextMenuConfig) ? null : getContextMenuComponent();
  const CurrentPath = currentPath && getCurrentPathComponent(currentPath);
  return <Wrapper aria-label="breadcrumb">
      <BreadcrumbsUI contextMenus={ContextMenus} currentPath={CurrentPath} />
    </Wrapper>;
};
export default OldBreadcrumbs;
export const Wrapper = /*#__PURE__*/styled('nav')({
  name: "Wrapper",
  class: "w12ntpec",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1fr5h4s",
  propsAsIs: false,
  vars: {
    "t1fr5h4s-0": [_exp()],
    "t1fr5h4s-1": [_exp2()],
    "t1fr5h4s-2": [_exp3(), "px"],
    "t1fr5h4s-3": [_exp4()]
  }
}));

require("./OldBreadcrumbs.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldBreadcrumbs.tsx");